import React from 'react';
import { LuImage } from 'react-icons/lu';
import './About.css';
import Seo from '../components/Seo';

const VALUES = [
  { title: 'Precision',    desc: 'Every detail matters. We treat every car like it\'s ours.' },
  { title: 'Convenience',  desc: 'We come to you — home, office, wherever works best.' },
  { title: 'Quality',      desc: 'Premium products, professional results, every single time.' },
  { title: 'Integrity',    desc: 'Honest pricing, transparent process, no surprises.' },
];

export default function About() {
  return (
    <div className="about">
      <Seo
        title="About Us | Cardona Auto Detailing"
        description="Meet Cardona Auto Detailing: professional mobile car detailing in Cookeville and Algood, TN. Precision, convenience, and premium quality."
        path="/about"
      />
      {/* PAGE HEADER */}
      <div className="page-header">
        <div className="page-header-bg"></div>
        <div className="page-header-overlay"></div>
        <div className="container page-header-content">
          <p className="section-label">Our Story</p>
          <h1 className="section-title">ABOUT<br />CARDONA</h1>
        </div>
      </div>

      {/* STORY */}
      <section className="page-section">
        <div className="container about-story">
          <div className="about-img-block">
            <div className="about-img-placeholder">
              <span><LuImage aria-hidden="true" /> Add team / owner photo here</span>
            </div>
          </div>
          <div className="about-text">
            <p className="section-label">Who We Are</p>
            <h2 className="section-title">PASSION FOR<br />CLEAN CARS</h2>
            <div className="gold-line"></div>
            <p>
              [Add your story here — how Cardona started, your passion for detailing,
              and what drives you every day to deliver the best results for your clients.]
            </p>
            <p style={{ marginTop: 20 }}>
              [Tell customers what makes you different — your training, experience,
              or the specific products and techniques you use.]
            </p>
            <div className="about-highlights">
              <div className="highlight-item">
                <strong>[Year]</strong>
                <span>Founded</span>
              </div>
              <div className="highlight-item">
                <strong>500+</strong>
                <span>Cars Detailed</span>
              </div>
              <div className="highlight-item">
                <strong>[City]</strong>
                <span>Based In</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* VALUES */}
      <section className="page-section values-section">
        <div className="container">
          <p className="section-label" style={{ textAlign: 'center' }}>What We Stand For</p>
          <h2 className="section-title" style={{ textAlign: 'center' }}>OUR VALUES</h2>
          <div className="gold-line" style={{ margin: '20px auto 48px' }}></div>
          <div className="values-grid">
            {VALUES.map((v, i) => (
              <div className="value-card" key={i}>
                <span className="value-num">0{i+1}</span>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TEAM */}
      <section className="page-section team-section">
        <div className="container">
          <p className="section-label">The People Behind the Polish</p>
          <h2 className="section-title">MEET THE TEAM</h2>
          <div className="gold-line"></div>
          <div className="team-grid">
            {[1,2,3].map(i => (
              <div className="team-card" key={i}>
                <div className="team-photo">
                  <span><LuImage aria-hidden="true" /> Photo</span>
                </div>
                <h3>[Team Member Name]</h3>
                <p>[Role / Title]</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
